// src/images/logos.js
import lightTextLogo from './light-text-logo.png';
import darkTextLogo from './dark-text-logo.png';
import lightLogo from './light-logo.png';
import darkLogo from './dark-logo.png';

const logos = {
  lightTextLogo,
  darkTextLogo,
  lightLogo,
  darkLogo,
};

export default logos;